import { LocalizedDatePipe } from '../../../shared/pipe/localized-date.pipe';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { ConfirmModalComponent } from '../../../shared/components/ui/confirm-modal/confirm-modal.component';
import { DataStateComponent } from '../../../shared/components/ui/data-state/data-state.component';
import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { OptionsService } from '../../../shared/services/options.service';
import {
  OPTION_CATEGORY_LABEL,
  VehicleOption,
} from '../../../shared/types/option.types';

@Component({
  selector: 'app-option-detail',
  imports: [
    CommonModule,
    RouterModule,
    LocalizedDatePipe,
    PageHeaderComponent,
    DataStateComponent,
    ConfirmModalComponent,
  ],
  templateUrl: './option-detail.component.html',
})
export class OptionDetailComponent implements OnInit {
  private readonly service = inject(OptionsService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  readonly item = signal<VehicleOption | null>(null);
  readonly loading = signal(true);
  readonly loadError = signal<string | null>(null);

  readonly deleteOpen = signal(false);
  readonly deleting = signal(false);
  readonly deleteError = signal<string | null>(null);

  readonly catLabel = OPTION_CATEGORY_LABEL;

  private id!: number;

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    const parsed = idParam ? Number(idParam) : NaN;
    if (!Number.isFinite(parsed)) {
      this.loadError.set('Identifiant invalide.');
      this.loading.set(false);
      return;
    }
    this.id = parsed;
    this.fetch();
  }

  fetch(): void {
    this.loading.set(true);
    this.loadError.set(null);
    this.service
      .get(this.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (o) => {
          this.item.set(o);
          this.loading.set(false);
        },
        error: (err: unknown) => {
          this.loading.set(false);
          this.loadError.set(
            toErrorMessage(err, 'Impossible de charger cet équipement.'),
          );
        },
      });
  }

  openDelete(): void { this.deleteError.set(null); this.deleteOpen.set(true); }
  closeDelete(): void { if (this.deleting()) return; this.deleteOpen.set(false); }
  confirmDelete(): void {
    this.deleting.set(true);
    this.deleteError.set(null);
    this.service
      .delete(this.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.deleting.set(false);
          this.deleteOpen.set(false);
          void this.router.navigate(['/options']);
        },
        error: (err: unknown) => {
          this.deleting.set(false);
          this.deleteError.set(
            toErrorMessage(err, 'errors.deleteFailed'),
          );
        },
      });
  }
}
